module.exports = __webpack_public_path__ + "static/media/logo-synapse24x24.20ea22a4.svg";